"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 320,
    sm: 380,
    md: 440,
    lg: 620,
    xl: 780,
    full: '100%',
};
exports.default = react_jss_1.createUseStyles({
    wrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    inner: function (_a) {
        var theme = _a.theme;
        return ({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowY: 'auto',
            padding: [theme.spacing.xl * 2, theme.spacing.md],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
        });
    },
    title: function (_a) {
        var theme = _a.theme;
        return ({
            marginRight: theme.spacing.md,
            textOverflow: 'ellipsis',
            display: 'block',
            wordBreak: 'break-word',
        });
    },
    modal: function (_a) {
        var theme = _a.theme, size = _a.size;
        return ({
            width: theme_1.getSizeValue({ sizes: exports.sizes, size: size }),
            padding: theme.spacing.lg,
            outline: 0,
        });
    },
    header: function (_a) {
        var theme = _a.theme;
        return ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: theme.spacing.md,
        });
    },
    body: function (_a) {
        var overflow = _a.overflow;
        return ({
            maxHeight: overflow === 'inside' && 'calc(100vh - 185px)',
            overflowY: overflow === 'inside' && 'auto',
            wordBreak: 'break-word',
        });
    },
}, { link: true });
